import { NavLink, Outlet, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { Smartphone, Route, Clock, Radio, BarChart3, Grid3X3, LayoutDashboard, LogOut } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/hooks/use-auth'
import { buildAppHref, clearAdminToken } from '@/lib/auth'

const tables = [
  { to: '/admin/overview', label: 'Overview', icon: LayoutDashboard },
  { to: '/admin/devices', label: 'Devices', icon: Smartphone },
  { to: '/admin/links', label: 'Links', icon: Route },
  { to: '/admin/travel-times', label: 'Travel Times', icon: Clock },
  { to: '/admin/sightings', label: 'Sightings', icon: Radio },
  { to: '/admin/base-tt', label: 'Base TT', icon: BarChart3 },
  { to: '/admin/base-data', label: 'Base Data', icon: Grid3X3 },
]

export function AdminLayout() {
  const auth = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  if (!auth || auth.mode !== 'admin') {
    return <Navigate to="/" replace />
  }

  if (location.pathname === '/admin' || location.pathname === '/admin/') {
    return <Navigate to={buildAppHref('/admin/devices', auth)} replace />
  }

  function handleLogout() {
    clearAdminToken()
    navigate('/', { replace: true })
  }

  return (
    <div className="flex h-screen overflow-hidden">
      <aside className="flex w-60 shrink-0 flex-col bg-[rgb(0,59,61)] text-white">
        {/* Logo */}
        <div className="flex h-14 items-center gap-2 px-5">
          <Route className="h-5 w-5 text-white/80" />
          <span className="text-lg font-bold">BT Travel Time</span>
        </div>

        {/* Nav */}
        <nav className="flex flex-1 flex-col gap-1 px-3 py-2">
          {tables.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={buildAppHref(to, auth)}
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors no-underline ${
                  isActive
                    ? 'bg-white/20 text-white'
                    : 'text-white/70 hover:bg-white/10 hover:text-white'
                }`
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Bottom */}
        <div className="border-t border-white/10 px-3 py-3">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleLogout}
            className="w-full justify-start text-white/70 hover:bg-white/10 hover:text-white"
          >
            <LogOut className="h-4 w-4" />
            Log out
          </Button>
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto p-8">
        <Outlet />
      </main>
    </div>
  )
}
